import {Intent, Position, Tooltip} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {Fragment, useEffect, useState} from "react";

const WarningContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const WarningIcon = styled(FontAwesomeIcon)`
  padding-right: 5px;
`;

type MapIconTooltipProps = {
  text?: string;
  isOpen?: boolean;
  children: JSX.Element[] | JSX.Element;
};

const MapIconTooltip = ({text, isOpen, children}: MapIconTooltipProps) => {
  const [warningDisplayed, setWarningDisplayed] = useState<boolean>(false);

  useEffect(() => {
    setWarningDisplayed(true);
    const timeoutId = setTimeout(() => {
      setWarningDisplayed(false);
    }, 3000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isOpen]);

  if (isOpen) {
    return (
      <Tooltip
        intent={Intent.NONE}
        popoverClassName="error-popover"
        position={Position.BOTTOM_RIGHT}
        isOpen={warningDisplayed}
        content={
          <WarningContainer>
            <WarningIcon size={"lg"} icon={solid("triangle-exclamation")} />
            <div>{text}</div>
          </WarningContainer>
        }
      >
        <React.Fragment>{children}</React.Fragment>
      </Tooltip>
    );
  } else {
    return <Fragment>{children}</Fragment>;
  }
};

export default MapIconTooltip;
